/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePrivateNoteRequest
 */
export interface UpdatePrivateNoteRequest {
    /**
     * New status for the private note
     * @type {string}
     * @memberof UpdatePrivateNoteRequest
     */
    status: UpdatePrivateNoteRequestStatusEnum;
}


/**
 * @export
 */
export const UpdatePrivateNoteRequestStatusEnum = {
    Active: 'ACTIVE',
    Handled: 'HANDLED',
    Archived: 'ARCHIVED',
    Deleted: 'DELETED'
} as const;
export type UpdatePrivateNoteRequestStatusEnum = typeof UpdatePrivateNoteRequestStatusEnum[keyof typeof UpdatePrivateNoteRequestStatusEnum];


/**
 * Check if a given object implements the UpdatePrivateNoteRequest interface.
 */
export function instanceOfUpdatePrivateNoteRequest(value: object): value is UpdatePrivateNoteRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdatePrivateNoteRequestFromJSON(json: any): UpdatePrivateNoteRequest {
    return UpdatePrivateNoteRequestFromJSONTyped(json, false);
}

export function UpdatePrivateNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePrivateNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function UpdatePrivateNoteRequestToJSON(json: any): UpdatePrivateNoteRequest {
    return UpdatePrivateNoteRequestToJSONTyped(json, false);
}

export function UpdatePrivateNoteRequestToJSONTyped(value?: UpdatePrivateNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

